<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h100-100">
        <div class="h-scroll h-wrapper-680">
          <div class="h-dialogContainer">
            <p>{{$t('System.mailTip')}}</p>
            <form id="mailServerForm">
              <div class="row h-row-inputBox">
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('System.smtpTip')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input :placeholder="$t('System.inputTipIp')" id="smtpIp" name="SmtpIp" v-model="serverIP" />
                    </div>
                  </div>
                </div>
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('System.mailAccount')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input :placeholder="$t('System.inputTipEmail')" id="email" name="Email" v-model="email" />
                    </div>
                  </div>
                </div>
              </div>
              <ejs-checkbox :label="$t('System.sslTlsTip')" ref="sslAndtls" :checked="false" :change="setChildStatus"></ejs-checkbox>
              <div class="row h-row-inputBox">
                <div class="col-sm-6 h-col-inputBox">
                  <ejs-checkbox label="SSL" ref="ssl" :checked="false" :change="setParentStatus"></ejs-checkbox>
                </div>
                <div class="col-sm-6 h-col-inputBox">
                  <ejs-checkbox label="TLS" ref="tls" :checked="false" :change="setParentStatus"></ejs-checkbox>
                </div>
              </div>
              <div class="row h-row-inputBox">
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('System.port')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input :placeholder="$t('System.inputTipPort')" id="port" name="Port" v-model="port" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row h-row-inputBox">
                <div class="form-group h-col-inputBox">
                  <ejs-checkbox :label="$t('System.smtpCheckTip')" ref="smtp" :checked="false" :change="setChecking"></ejs-checkbox>
                </div>
              </div>
              <div class="row h-row-inputBox">
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('System.userCheck')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input id="checkName" name="CheckName" v-bind:disabled="isReadOnly" v-model="userName"/>
                    </div>
                  </div>
                </div>
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('System.passwordCheck')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input type="password" id="checkPassword" name="CheckPassword" v-bind:disabled="isReadOnly" v-model="userPassword"/>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="b-t"></div>
        <div class="h-scroll h-system-wrapper-680">
          <div class="h-bottom-btnBox h-system-btnBox">
            <div class="row">
              <div class="col-sm-12 h-col-inputBox">
                <ejs-button cssClass="e-control e-btn e-lib e-flat" @click.native="reset">{{$t('System.reset')}}</ejs-button>
                <ejs-button ref="teButton" cssClass="e-control e-btn e-lib e-flat" @click.native="test">{{$t('System.test')}}</ejs-button>
                <ejs-button ref="apButton" cssClass="e-control e-btn e-lib e-primary e-flat" @click.native="apply">{{$t('System.apply')}}</ejs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import mixin from '../../mixin/mixin';
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "MailServer",
  mixins: [mixin],
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: {
        show: true,
        crumb: `${this.$t('System.systemManager')}/${this.$t("System.systemNotice")}/${this.$t("System.serviceSet")}`
      },
      serverIP: "127.0.0.1",
      email: "123@qq.com",
      port: "25",
      userName: "",
      userPassword: "",
      formObj: "",
      isReadOnly: "",
      isSSL: 0, //smtp服务器请求SSL/TLS请求类型 ssl or tls
      isTLS: 0,
      isVerify: 0, // smtp服务器是否要求身份验证
      inputNames: ['SmtpIp', 'Email', 'Port', 'CheckName', 'CheckPassword'],
      rules: {
        SmtpIp: {
          required: [true, `${this.$t('MML.notValidDomainOrIp')}`],
          regex: ['^((([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])$)|^((\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$)' , `${this.$t('MML.notValidDomainOrIp')}`]
        },
        Email: { required: true, email: true },
        Port: { required: true, number: true, min: 1, max: 65535, regex: 'integer' },
        CheckName: { required: true, minLength: 6, maxLength: 32},
        CheckPassword: { required: true, minLength: 1, maxLength: 32 }
      }
    };
  },
  components: {
    BasicLayout,
    CustomDialog
  },
  methods: {
    reset() {
      Object.keys(this.rules).forEach((item) =>{
        let id = item+"-info";
        if(document.getElementById(id)){
          document.getElementById(id).style.display = "none" ;
        }
      });
      this.getConfig();
    },
    test() {
      const url = "/lte/ems/sysmanager/mail/testconnection";
      if (!this.formObj.validate()){
        return null;
      };
      this.$loading.showLoadding(`${this.$t('System.testLoading')}`);
      this.send(url);
    },
    apply() {
      const url = "/lte/ems/sysmanager/mail/updatemailconfig";
      this.formObj = this.validateForm('mailServerForm', this.inputNames, this.rules);
      if (!this.formObj.validate()){
        return null;
      };
      this.send(url);
    },
    send(url) {
      const params = {
        ip: this.serverIP,
        isSsl: this.isSSL,
        isTls: this.isTLS,
        isVerify: this.isVerify,
        mailFrom: this.email,
        password: this.userPassword,
        port: this.port,
        userName: this.userName
      };
      this.axios.post(url, params).then(response => {
        this.$loading.hideLoadding();
        if(response.status==200 && response.data){
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Common.tips.success')}`});
        }else{
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('Common.tips.failure')}`});
        }
      });
      setTimeout(() => {
        console.log(this.$loading.status());
        if(this.$loading.status() == 1){
          this.$loading.hideLoadding();
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('DataManagent.requestTimeOut')}`});
        }
      }, 15000);
    },
    setChildStatus() {
      let sslAndtls = this.$refs.sslAndtls.ej2Instances;
      let ssl = this.$refs.ssl.ej2Instances;
      let tls = this.$refs.tls.ej2Instances;
      if (sslAndtls.checked === true) {
        ssl.checked = true;
        tls.checked = true;
      } else {
        ssl.checked = false;
        tls.checked = false;
      }
      this.setSslTlsValue(ssl, tls);
    },
    setParentStatus() {
      let sslAndtls = this.$refs.sslAndtls.ej2Instances;
      let ssl = this.$refs.ssl.ej2Instances;
      let tls = this.$refs.tls.ej2Instances;
      if (ssl.checked === true && tls.checked === true) {
        sslAndtls.indeterminate = false;
        sslAndtls.checked = true;
      } else if (ssl.checked === false && tls.checked === false) {
        sslAndtls.indeterminate = false;
        sslAndtls.checked = false;
      } else {
        sslAndtls.indeterminate = true;
      }
      this.setSslTlsValue(ssl, tls);
    },
    setSslTlsValue(ssl, tls) {
      if (ssl.checked) {
        this.isSSL = 1;
      } else {
        this.isSSL = 0;
      }
      if (tls.checked) {
        this.isTLS = 1;
      } else {
        this.isTLS = 0;
      }
    },
    setChecking() {
      let smtp = this.$refs.smtp.ej2Instances.checked;
      this.isReadOnly = !smtp;
      if (smtp) {
        this.isVerify = 1;
      } else {
        this.isVerify = 0;
      }
      this.$nextTick(() => {
        this.reBindForm();
      });
    },
    reBindForm(){
      this.formObj = this.validateForm('mailServerForm', this.inputNames, this.rules);
      this.$refs.smtp.ej2Instances.refresh();
      this.$refs.sslAndtls.ej2Instances.refresh();
      this.$refs.ssl.ej2Instances.refresh();
      this.$refs.tls.ej2Instances.refresh();
    },
    getConfig() {
      const url = "/lte/ems/sysmanager/mail/getmailconfig";
      this.axios.get(url).then(response => {
        let result = response.data;
        if (result == null || result == "") {
          return null;
        }
        this.serverIP = result.ip;
        this.email = result.mailFrom;
        this.port = result.port;
        this.userName = result.userName;
        this.userPassword = result.password;
        this.isVerify = result.isVerify;
        this.isSsl = result.isSsl;
        this.isTls = result.isTls;
        if (result.isSsl === 1) {
          this.$refs.ssl.ej2Instances.checked = true;
        }
        if (result.isTls === 1) {
          this.$refs.tls.ej2Instances.checked = true;
        }
        if (result.isVerify === 1) {
          this.$refs.smtp.ej2Instances.checked = true;
          this.isReadOnly = false;
        }
        this.setParentStatus();
      });
    }
  },
  mounted() {
    this.formObj = this.validateForm('mailServerForm', this.inputNames, this.rules);
    this.getConfig();
  }
};
</script>

<style>

</style>
